var url = window.location.host;
var testing_url = "https://mapapi.sahapedia.org/";
var apiURL = testing_url;

module.exports = apiURL;